/* Too Munchies · carrito: interruptor "Asegura tu pedido", producto add-on y re-render del cajón */
(function () {
  'use strict';

  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function headers() {
    return { 'Content-Type': 'application/json', Accept: 'application/json' };
  }
  function cartRoutes() {
    var r = window.routes || {};
    return {
      add: r.cart_add_url || '/cart/add',
      change: r.cart_change_url || '/cart/change',
      cart: r.cart_url || '/cart'
    };
  }
  function drawer() {
    return document.querySelector('cart-drawer');
  }
  function setBusy(el, busy) {
    if (!el) return;
    var box = el.closest('[data-tm-cart-insurance], [data-tm-cart-addon]') || el;
    box.classList.toggle('is-busy', !!busy);
    if (el.tagName === 'BUTTON' || el.tagName === 'INPUT') el.disabled = !!busy;
  }
  function render(state) {
    var d = drawer();
    if (!d || !state || !state.sections) return;
    if (typeof state.item_count === 'number') {
      d.classList.toggle('is-empty', state.item_count === 0);
    } else {
      d.classList.remove('is-empty');
    }
    d.renderContents(state);
    if (window.publish && window.PUB_SUB_EVENTS) {
      try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'tm-cart', cartData: state }); } catch (e) {}
    }
  }
  function addVariant(variantId) {
    return fetch(cartRoutes().add, {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: SECTIONS, sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); });
  }
  function changeLine(key, qty) {
    return fetch(cartRoutes().change, {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify({ id: key, quantity: qty, sections: SECTIONS, sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); });
  }
  function findLineKey(variantId) {
    return fetch(cartRoutes().cart + '.js', { headers: headers() })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var item = (cart.items || []).find(function (i) { return String(i.variant_id) === String(variantId); });
        return item ? item.key : null;
      });
  }
  function removeVariant(key, variantId) {
    var p = key ? Promise.resolve(key) : findLineKey(variantId);
    return p.then(function (k) {
      if (!k) return null;
      return changeLine(k, 0);
    });
  }
  function reportError(state) {
    var box = document.getElementById('CartDrawer-CartErrors');
    if (box && state && (state.description || state.message)) {
      box.textContent = state.description || state.message;
      setTimeout(function () { box.textContent = ''; }, 4000);
    }
  }

  /* Interruptor de seguro */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-tm-cart-toggle]');
    if (!input) return;
    var variantId = input.getAttribute('data-variant-id');
    var key = input.getAttribute('data-line-key');
    setBusy(input, true);
    var op = input.checked ? addVariant(variantId) : removeVariant(key, variantId);
    op.then(function (state) {
      if (!state) { setBusy(input, false); return; }
      if (state.status && state.status >= 400) {
        input.checked = !input.checked;
        reportError(state);
        setBusy(input, false);
        return;
      }
      render(state);
    }).catch(function () { input.checked = !input.checked; setBusy(input, false); });
  });

  /* Add-on: agregar / quitar */
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-tm-cart-add]');
    var removeBtn = e.target.closest('[data-tm-cart-remove]');
    if (!addBtn && !removeBtn) return;
    var btn = addBtn || removeBtn;
    setBusy(btn, true);
    var op = addBtn
      ? addVariant(addBtn.getAttribute('data-tm-cart-add'))
      : removeVariant(removeBtn.getAttribute('data-tm-cart-remove'), null);
    op.then(function (state) {
      if (!state) { setBusy(btn, false); return; }
      if (state.status && state.status >= 400) { reportError(state); setBusy(btn, false); return; }
      render(state);
    }).catch(function () { setBusy(btn, false); });
  });

  /* Animar la barra de meta al renderizar (setTimeout + reflow: funciona aunque la pestaña esté en segundo plano) */
  function animateGoal(scope) {
    (scope || document).querySelectorAll('.tm-cart-goal:not(.is-animated)').forEach(function (bar) {
      void bar.offsetWidth;
      setTimeout(function () { bar.classList.add('is-animated'); }, 40);
    });
  }
  var mo = new MutationObserver(function () { animateGoal(); });
  function init() {
    animateGoal();
    var d = drawer();
    if (d) mo.observe(d, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
